/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationSyncRequest {
    getFixupPrototypeFunction() { return CustomMetricConfigurationSyncRequest.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationSyncRequest>): CustomMetricConfigurationSyncRequest {
        let obj = Object.assign(new CustomMetricConfigurationSyncRequest(), model);
        CustomMetricConfigurationSyncRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationSyncRequest>): CustomMetricConfigurationSyncRequest {
        if (!model) return null;
        return CustomMetricConfigurationSyncRequest.newInstance(<CustomMetricConfigurationSyncRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationSyncRequest) {
        if (!obj) return;

        models.CustomMetricConfigurationSyncRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationSyncRequest): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationSyncRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud Account ID for which the sync to be triggered.
     */
    service_account_id: string;

}
